import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../ui/dialog";
import { Apple, Smartphone } from "lucide-react";
import BrandHeart from "./BrandHeart";

export default function ComingSoonDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-md rounded-2xl border-qh-line"
        data-testid="coming-soon-dialog"
      >
        <DialogHeader className="items-center text-center">
          <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-[#FFE4E6]">
            <BrandHeart className="w-7 h-7" alt="QHearts" />
          </div>
          <DialogTitle className="font-display text-2xl font-semibold text-qh-ink">
            Gleich für dich da.
          </DialogTitle>
          <DialogDescription className="text-qh-slate leading-relaxed">
            QHearts startet in Kürze auf iOS und Android. Trag dich auf die
            Warteliste ein — deine Einladung kommt, sobald wir öffnen.
          </DialogDescription>
        </DialogHeader>

        <div className="mt-4 grid grid-cols-2 gap-3">
          <div className="flex items-center gap-2 rounded-xl border border-qh-line px-4 py-3 bg-white">
            <Apple className="w-5 h-5" strokeWidth={1.5} />
            <div className="text-xs">
              <div className="text-qh-slate">iOS</div>
              <div className="font-medium text-qh-ink">Bald verfügbar</div>
            </div>
          </div>
          <div className="flex items-center gap-2 rounded-xl border border-qh-line px-4 py-3 bg-white">
            <Smartphone className="w-5 h-5" strokeWidth={1.5} />
            <div className="text-xs">
              <div className="text-qh-slate">Android</div>
              <div className="font-medium text-qh-ink">Bald verfügbar</div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
